import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { auth } from './modules/auth';
import { loading } from './modules/loading';
import { message } from './modules/message';
import { tab } from './modules/tab';
import { userAgent } from './modules/user_agent';
import { category } from './modules/category';
import { contractPartyMaster } from './modules/contract_party_master';
import { companyContractTag } from './modules/company_contract_tag';
import { user } from './modules/user';
import { review } from './modules/review';
import { searchJoubun } from './modules/search_joubun';
import { diff } from './modules/diff';
import { userMetaLog } from './modules/user_meta_log';
import { userTemplate } from './modules/user_template';
import { userSettings } from './modules/user_settings';
import { showHeader } from './modules/showHeader';
import { version } from './modules/version';
import { checkPoint } from './modules/checkPoint';
import { userContractVersion } from './modules/user_contract_version';

// Status List
import { languageCode } from './status_list/language_code';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    loading,
    message,
    tab,
    userAgent,
    languageCode,
    category,
    contractPartyMaster,
    companyContractTag,
    user,
    review,
    searchJoubun,
    diff,
    userMetaLog,
    userTemplate,
    userSettings,
    showHeader,
    version,
    checkPoint,
    userContractVersion
  },
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      paths: [
        'auth',
        'loading',
        'message',
        'tab',
        'userAgent',
        'languageCode',
        'category',
        'contractPartyMaster',
        'companyContractTag',
        'user',
        'review',
        'searchJoubun',
        'diff',
        'userMetaLog',
        'userTemplate',
        'userSettings',
        'showHeader',
        'version',
        'userContractVersion'
      ]
    }),
    createPersistedState({
      storage: window.localStorage,
      paths: ['checkPoint']
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js